/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageContainer } from '../models/ImageContainer';
import type { LineOaFinancierConnectionConfig } from '../models/LineOaFinancierConnectionConfig';
import type { LineOaFinancierPaymentAlmostDueNotificationConfig } from '../models/LineOaFinancierPaymentAlmostDueNotificationConfig';
import type { LineOaFinancierPaymentAppointmentNotificationConfig } from '../models/LineOaFinancierPaymentAppointmentNotificationConfig';
import type { LineOaFinancierPaymentConfirmedNotificationConfig } from '../models/LineOaFinancierPaymentConfirmedNotificationConfig';
import type { LineOaFinancierPaymentDueTodayNotificationConfig } from '../models/LineOaFinancierPaymentDueTodayNotificationConfig';
import type { LineOaFinancierPaymentPastDueNotificationConfig } from '../models/LineOaFinancierPaymentPastDueNotificationConfig';
import type { LineOaFinancierWelcomeNotificationConfig } from '../models/LineOaFinancierWelcomeNotificationConfig';
import type { MessageQuotaResult } from '../models/MessageQuotaResult';
import type { VerificationResult } from '../models/VerificationResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LineOaFinancierService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the Line OA welcome notification configuration for a specific financier.
     * @returns LineOaFinancierWelcomeNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierWelcomeNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierWelcomeNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/welcome/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA welcome notification configuration for a specific financier.
     * @returns LineOaFinancierWelcomeNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierWelcomeNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierWelcomeNotificationConfig,
    }): CancelablePromise<LineOaFinancierWelcomeNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/welcome/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment past due notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentPastDueNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierPaymentPastDueNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierPaymentPastDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-past-due/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment past due notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentPastDueNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierPaymentPastDueNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierPaymentPastDueNotificationConfig,
    }): CancelablePromise<LineOaFinancierPaymentPastDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-past-due/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment due today notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentDueTodayNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierPaymentDueTodayNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierPaymentDueTodayNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-due-today/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment due today notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentDueTodayNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierPaymentDueTodayNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierPaymentDueTodayNotificationConfig,
    }): CancelablePromise<LineOaFinancierPaymentDueTodayNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-due-today/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment confirmed notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentConfirmedNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierPaymentConfirmedNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierPaymentConfirmedNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-confirmed/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment confirmed notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentConfirmedNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierPaymentConfirmedNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierPaymentConfirmedNotificationConfig,
    }): CancelablePromise<LineOaFinancierPaymentConfirmedNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-confirmed/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment appointment notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentAppointmentNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierAppointmentNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierPaymentAppointmentNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-appointment/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment appointment notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentAppointmentNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierAppointmentNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierPaymentAppointmentNotificationConfig,
    }): CancelablePromise<LineOaFinancierPaymentAppointmentNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-appointment/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA payment almost due notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentAlmostDueNotificationConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierPaymentAlmostDueNotificationConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierPaymentAlmostDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-almost-due/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA payment almost due notification configuration for a specific financier.
     * @returns LineOaFinancierPaymentAlmostDueNotificationConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierPaymentAlmostDueNotificationConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierPaymentAlmostDueNotificationConfig,
    }): CancelablePromise<LineOaFinancierPaymentAlmostDueNotificationConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/notification/payment-almost-due/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Retrieves the Line OA connection configuration for a specific financier.
     * @returns LineOaFinancierConnectionConfig OK
     * @throws ApiError
     */
    public getLineOaFinancierConnectionConfig({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierConnectionConfig> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/config',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Updates the Line OA connection configuration for a specific financier.
     * @returns LineOaFinancierConnectionConfig OK
     * @throws ApiError
     */
    public updateLineOaFinancierConnectionConfig({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LineOaFinancierConnectionConfig,
    }): CancelablePromise<LineOaFinancierConnectionConfig> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/financiers/{financierId}/line-oa/config',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get the rich menu for a specific financier.
     * @returns ImageContainer OK
     * @throws ApiError
     */
    public getLineOaRichMenuImage1({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<ImageContainer> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/rich-menu/image',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Set the rich menu for a specific financier.
     * @returns any OK
     * @throws ApiError
     */
    public setLineOaRichMenuImage1({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: ImageContainer,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/financiers/{financierId}/line-oa/rich-menu/image',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get the message quota for a specific financier.
     * @returns MessageQuotaResult OK
     * @throws ApiError
     */
    public getLineOaMessageQuota1({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<MessageQuotaResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/message-quota',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Verifies the Line OA configuration for a specific financier.
     * @returns VerificationResult OK
     * @throws ApiError
     */
    public verifyLineOaConfig1({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<VerificationResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/financiers/{financierId}/line-oa/config/verify',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
